import { FormValidator } from '~/modules';

export const validationSchema = (pixKey: string) =>
  FormValidator.object().shape({
    CreditSimulationPixKeyConfirmation: FormValidator.string()
      .required('Confirme a chave PIX informada na tela anterior')
      .test(
        'pixKeyConfirmationMatch',
        'A chave PIX deve ser a mesma informada na tela anterior',
        (value) => value === pixKey,
      ),
  });

export type CreditSimulationPixKeyConfirmationFormValues = Record<
  'CreditSimulationPixKeyConfirmation',
  string
>;

export const initialValues: CreditSimulationPixKeyConfirmationFormValues = {
  CreditSimulationPixKeyConfirmation: '',
};
